import { ConversationMode } from "../../../common/Constants";
import { isNullOrUndefined } from "../../../common/utils";
export const isPostChatSurveyEnabled = async facadeChatSDK => {
  var _chatConfig$LiveWSAnd;
  const chatConfig = await facadeChatSDK.getLiveChatConfig();
  const postChatEnabled = (_chatConfig$LiveWSAnd = chatConfig.LiveWSAndLiveChatEngJoin) === null || _chatConfig$LiveWSAnd === void 0 ? void 0 : _chatConfig$LiveWSAnd.msdyn_postconversationsurveyenable.toString().toLowerCase();
  return postChatEnabled === "true";
};
export const isPersistentChatEnabled = async conversationMode => {
  if (isNullOrUndefined(conversationMode)) {
    return false;
  }
  return (conversationMode === null || conversationMode === void 0 ? void 0 : conversationMode.toString().toLowerCase()) === ConversationMode.Persistent;
};